<template>
	<div class="center">
		<h1>TestProductSearch</h1>
		<div class="flexcenter">
			<Button label="Rebuild search-model" @click="rebuild()" />

			<Icon icon="reload" :class="this.spinning ? 'spinner' : ''" />
		</div>

		<input type="checkbox" v-model="autoSearch" />Autosök (tryck enter för att söka annars)

		<div class="form textField" :title="'filter: ' + this.filter" style="margin-top:10px;">
			<input type="text" placeholder="Sök efter produkter, tillverkare, mc-modeller." v-model="this.filterInput"
				@keypress.enter="enterPressed">


			<img src="@/assets/button_close_dark.png" @click="this.filterInput = ''" style="margin-right:5px;" />
			<Button label="Sök" @click="enterPressed" />

		</div>

		<div style="margin-top:10px;background:var(--grey-5);padding:5px;border-radius: 5px;">
			<h3>Search model - totalt: {{ this.searchModel.productList.filter(item => item !== null).length }}</h3>

			<div
				style="background:var(--grey-2);margin-top:5px;margin-bottom:5px;padding:5px;min-height:50px;max-height:300px;overflow:scroll;border-radius: 5px;">
				<h5>ProductList</h5>
				<div v-for="(item) in this.searchModel.productList.filter(item => item !== null).slice(0, 100)"
					:key="item.entityId"
					style="background:var(--grey-6);border-radius: 5px;padding:10px;color:white;margin-bottom:5px;">
					<b>Product: {{ item.entityId }} </b><br />
					Important:
					<div class="flexcenter">
						<div v-for="(importantKeyword, index) in item.importantKeywords" :key="index"
							style="background:var(--grey-dark-1);padding:5px;margin-bottom:5px;border-radius:5px;">

							{{ importantKeyword }}

						</div>
					</div>
					Keywords:
					<div class="flexcenter">
						<div v-for="(keyword, index) in item.keywords" :key="index"
							style="background:var(--grey-dark-1);padding:5px;margin-bottom:5px;border-radius:5px;">

							{{ keyword }}

						</div>
					</div>

					Text:

					<div style="background:var(--grey-dark-1);padding:5px;margin-bottom:5px;border-radius:5px;">

						{{ item.text }}

					</div>

				</div>
			</div>
		</div>

		<div style="margin-top:10px;background:var(--grey-5);padding:5px;border-radius: 5px;">
			<h3>Product search config</h3>
			<div
				style="background:var(--grey-2);margin-top:5px;margin-bottom:5px;padding:5px;min-height:50px;max-height:300px;overflow:scroll;border-radius: 5px;">
				{{ this.searchProductConfig }}
			</div>
		</div>

		<div style="margin-top:10px;background:var(--grey-5);padding:5px;border-radius: 5px;">
			<h3>Product search result</h3>
			<div v-if="this.searchProductResult && this.searchProductResult.productList"
				style="background:var(--grey-2);margin-top:5px;margin-bottom:5px;padding:5px;min-height:50px;max-height:300px;overflow:scroll;border-radius: 5px;">

				<!-- sökresultat header -->
				<div v-if="this.searchProductResult && this.searchProductResult.meta"
					style="background:var(--grey-6);margin-bottom:10px;padding:10px;color:white;border-radius: 5px;">
					{{ this.searchProductResult.meta }} Antal: {{ this.searchProductResult && this.searchProductResult.productList
						? this.searchProductResult.productList.length : '' }}
				</div>

				<!-- sökresultat lista -->

				<div v-for="(entity) in this.searchProductResult.productList.filter(entity => entity !== null).slice(0, 100)"
					:key="entity.entityId"
					style="background:var(--grey-6);border-radius: 5px;padding:10px;color:white;margin-bottom:5px;">
					<div class="flexcenter" style="align-items:baseline;">
						<h3 style="color:white;">{{ entity.search.totalScore }}</h3>
						{{ entity.importantKeywords.join(" ") }},
						{{ entity.keywords.join(" ") }},
						{{ entity.text }}
					</div>

					<div><b @click="entity.search.showScoreList = !entity.search.showScoreList">Score {{
						entity.search.totalScore
							}}</b>

						<div v-if="entity.search">

							<div
								v-for="(score, index) in entity.search.scoreList.filter(score => score && score.score > 0).sort((a, b) => (b.score - a.score))"
								:key="index" style="background:var(--bg-ok);padding:3px;margin-bottom:3px;border-radius: 5px;">

								{{ score.score }}: {{ score.description }}

							</div>

							<hr />
							<div v-if="entity.search.showScoreList">
								<div v-for="(score, index) in entity.search.scoreList" :key="index"
									style="background:var(--bg-message);padding:3px;margin-bottom:3px;border-radius: 5px;">

									{{ score.score }}: {{ score.description }}
								</div>
							</div>
						</div>
					</div>
					<hr />

				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { STORE_ACTION, STORE_COMMIT, STORE_GETTER } from '../../store/store';
import searchUtil from '../../store/store-search-utils';

export default {
	name: "TestProductSearch",
	components: {},
	mixins: [],
	data() {
		return {
			filterInput: "",
			filter: "",
			spinning: false,
			autoSearch: true
		};
	},
	watch: {
		filterInput: function (newFilter, oldFilter) {

			if (!this.autoSearch) {
				const searchProductConfig = this.searchProductConfig
				searchProductConfig.searchPhrase = newFilter
				this.$store.commit(STORE_COMMIT.SET_SEARCH_PRODUCT_CONFIG, searchProductConfig)
				return;
			}


			if (newFilter.length == 0) {
				console.log("FP: watcher: filter input == 0");
				return;

			}

			if (newFilter.length < 3) {
				console.log("FP: watcher: filter input < 3");
				return;

			}

			if (oldFilter.includes(newFilter) && !newFilter.endsWith(" ")) { // om man suddar, men inte om man suddar klart ett ord
				console.log('FP: watcher: sudda');
				return;

			}

			// om sista ordet är längre än 2 tecken. 
			const last = newFilter.split(" ").slice(-1)[0]

			if (last.length < 3) {
				console.log('FP: last < 3 ', last);
				return;
			}

			if (newFilter.endsWith(" ")) {
				console.log("FP: watcher: slutar med space");
			}

			console.log('FP: SÖK: ', newFilter);

			const searchProductConfig = this.searchProductConfig

			searchProductConfig.searchPhrase = newFilter

			this.$store.commit(STORE_COMMIT.SET_SEARCH_PRODUCT_CONFIG, searchProductConfig)

			this.triggerSearch()


		}
	},
	computed: {



		searchModel() {
			return this.$store.getters[STORE_GETTER.SEARCH_MODEL];

			//return searchModel.productList.filter(item => item !== null);
		},

		searchProductResult() {
			return this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_RESULT];
		},
		searchProductConfig() {
			return this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_CONFIG];
		}



	},
	methods: {

		rebuild() {
			// FP: 2026: VO2: this.$store.commit(STORE_COMMIT.REBUILD_SEARCH_MODEL, false);
			this.$store.dispatch({ type: STORE_ACTION.REBUILD_SEARCH_MODEL_ACTION }).then(() => {
				//
			})
		},


		triggerSearchX() {
			console.log('FP: TriggerSearch: ');
			//this.$store.commit(STORE_COMMIT.SEARCH_PRODUCT);

			var data = { productList: this.searchModel.productList.filter(product => product !== null) }
			this.spinning = true
			this.$store.dispatch({ type: STORE_ACTION.SEARCH_PRODUCT_A, data: data }).then(result => {

				console.log('FP: result', result);
				alert("Done")
				this.spinning = true

			})


		},

		enterPressed() {


			const searchProductConfig = this.searchProductConfig

			searchProductConfig.searchPhrase = this.filterInput

			this.$store.commit(STORE_COMMIT.SET_SEARCH_PRODUCT_CONFIG, searchProductConfig)

			this.triggerSearch()
		},

		triggerSearch() {


			if (this.spinning) {
				console.log('FP: SÖK: skip search');

				return;
			}


			this.spinning = true;

			console.log('FP: SÖK: Start search');

			this.$store.dispatch({ type: STORE_ACTION.SEARCH_PRODUCT_A, data: { productList: this.searchModel.productList } }).then(result => {
				console.log('FP: SÖK: Done: ', result);
				this.spinning = false;

				if (result.currentSearchPhrase != this.searchProductConfig.searchPhrase) {
					console.log('FP: SÖK: Start re-search');
					this.triggerSearch()
				}

				//alert("OK");



			}).finally(() => {
				//alert("ok")
				console.log('FP: search done');
			})


			/*searchUtil.searchProductA(null, "prod", this.searchModel.productList).then(result => {
				console.log('FP: Done: ', result);

			})*/
		},

		async search() {



			/*
			searchProductA(resultMeta, searchPhrase, productList) // fortsätt här
	
			*/

			// skapa en lista av produkter att söka i 
			/*searchProductConfig.productIdList.forEach(entityId => {
	
				const entity = state.searchModel.productList[entityId];
				entity.search = { totalScore: 0, scoreList: [], showScoreList: false }
				productList[entityId] = entity;
	
			});*/


			//var data = { productList: this.searchModel.productList }


			console.log('FP: Start search');

			const searchProductResult = await searchUtil.searchProductSlow()

			if (searchProductResult) {

				console.log('FP: searchProductResult OK', searchProductResult);
				return searchProductResult

			}

			//commit("setSearchProductResult", searchProductResult)

			console.log('FP: Start search DONE');

			/*
			await searchUtil.searchProductA(null, "prod", data.productList).then(searchProductResult => {
				commit("setSearchProductResult", searchProductResult)
				console.log('FP: Start search DONE');
	
			})*/

			//return Promise.resolve(searchProductResult);

		}

	},
	created() {
		this.rebuild();

		/*
		var entity = { text: "Description about product... fits Honda CBR 929 Fireblade, Blue Headlight" }

		const searchWord = "e H";

		const diff = entity.text.toLowerCase().length - entity.text.toLowerCase().replaceAll(searchWord.toLowerCase(), "").length;

		if (diff > 0) {
			alert("Textsökning: " + entity.text.substring(0, 100) + ": searchWord:" + searchWord + ": diff: " + diff);
		} else {
			alert("Textsökning: " + entity.text.substring(0, 100) + ": searchWord:" + searchWord + ": ingen träff");
		}

		console.log('FP: entitySearch: ', entity.search);
*/

	}
};
</script>

<style scoped></style>